import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';

const resources = {
    en: {
        common: enTranslations
    },
    de: {
        common: deTranslations
    },
    'de-DE': {
        common: deTranslations
    }
};

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: false,

        saveMissing: false,
        missingKeyHandler: false,

        // Set default language
        lng: 'en',
        fallbackNS: 'en',

        defaultNS: 'common',
        ns: ['common'],

        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'language'
        },

        // Interpolation options
        interpolation: {
            escapeValue: false,
            format: (value, format, lng) => {
                if (format === 'uppercase') return value.toUpperCase();
                if (format === 'lowercase') return value.toLowerCase();
                if (format === 'capitalize') return value.charAt(0).toUpperCase() + value.slice(1);
                return value;
            }
        },

        // React options
        react: {
            useSuspense: true,
            bindI18n: 'languageChanged',
            bindI18nStore: '',
            transEmptyNodeValue: '',
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        }
    });

export default i18n;
